import { clientTypes } from "../../type/clientTypes";

const initialState = {
  searchLoading: false,
  isLoading: false,
  data: [],
  msg: "",
  count: "",
};

export const getUserListReducer = (state = initialState, action) => {
  switch (action.type) {
    case clientTypes.GET_USER_DATA_PENDING:
      return {
        ...state,
        searchLoading: action.isLoading,
        isLoading: true,
        msg: "",
      };
    case clientTypes.GET_USER_DATA_SUCCESS:
      return {
        ...state,
        searchLoading: action.isLoading,
        data: action.payload,
        isLoading: false,
        msg: action.msg,
        count: action.count,
      };
    case clientTypes.GET_USER_DATA_FAILED:
      return {
        ...state,
        searchLoading: action.isLoading,
        data: action.payload,
        msg: action.msg,
        isLoading: false,
      };
    default:
      return state;
  }
};
